export default {
  name: 'BaseDaterangePicker',

  props: ['start', 'end'],

  render (h) {
    const { start, end, $listeners: on, $attrs: attrs } = this
    const value = attrs.hasOwnProperty('value') ? attrs.value : [start, end].filter(i => !!i)
    const handler = (e) => {
      const [start = '', end = ''] = e || []
      this.$emit('update:start', start)
      this.$emit('update:end', end)
    }
    return <el-date-picker
      type="datetimerange"
     
      value={value}
      onInput={handler}
      {...{ on, attrs }}
    />
  }
}
